define('views/modules/template/assignment/manager/per-user/per-user-manager-content',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'moment',
    'utils',
    // services
    'services/events/calendar-events',
    'services/i18n',
    // views
    'views/modules/template/assignment/list/per-user/per-user-assignment-list',
    'views/parts/menu/menu-action',
    'views/parts/alert/alert-no-data',
    // template
    'text!templates/modules/template/assignment/manager/per-user-manager-content.html'
], function(
    // Libs
    _, Backbone, Mustache, moment, U,
    // services
    CalendarEvents,
    i18n,
    // views
    VPerUserAssignmentList,
    VMenuAction,
    VAlertNoData,
    // template
    TAssignmentManagerContent
) {

    var VPerUserAssignmentManagerContent = Backbone.View.extend({
        template: TAssignmentManagerContent,

        regions: {
            list: '.assignment-list',
            menu: '.menu-actions',
            alert: '.alert-no-data'
        },

        initialize: function(opt) {

            _.extend(this, {
                group: opt.group,
                profile: opt.profile,
                url: opt.url
            });

            var collection = this.collection;

            this.view = {
                menu: new VMenuAction({
                    context: this,
                    onClick: this.onActionClick,
                    collection: new Backbone.Collection([
                        { title: i18n.t('messages:tooltip-assign-template'), content: '<strong>+</strong>', skipTranslation: 'true', btnClass: 'btn-tc-custom', itemClass: 'big-action', callback: this.onNewAssignmentAction },
                    ]),
                    tooltip: {
                        container: this.regions.root
                    }
                }),
                list: new VPerUserAssignmentList({ collection: collection }),
                alert: new VAlertNoData({
                    title: 'Assign a template',
                    subtitle: 'Click on + to assign your first template',
                    collection: collection
                }),
            };

            this.listenTo(collection, {
                'destroy': this.onModelDestroy,
            });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.alert, zone.$alert)
                .assign(view.list, zone.$list);
        },

        /////////////
        // actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onModelDestroy: function(model, collection) {
            CalendarEvents.templateAssign();
        },

        onNewAssignmentAction: function() {
            Backbone.history.redirect(Mustache.render(this.url.root + 'assign/', {
                dayId: moment().format('YYYY-MM-DD'),
                userId: this.profile.id,
                groupId: this.group.id
            }));
        }
    });

    return VPerUserAssignmentManagerContent;

});

